import React from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";

const useStyles = makeStyles(theme => ({
  root: {
    width: props => (props.small ? 100 : 300)
  },
  card: {
    width: props => (props.small ? 100 : 300),
    border: props =>
      `1px solid ${props.selected ? theme.palette.primary.dark : "transparent"}`
  },
  label: {
    marginTop: theme.spacing(1)
  },
  media: {
    height: props => (props.small ? 100 : 250),
    backgroundSize: "contain",
    filter: props => `grayscale(${props.grayscale ? 1 : 0})`
  },
  selected: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translateY(-50%) translateX(-50%)"
  }
}));

function BasicCard({
  grayscale,
  id,
  name,
  image,
  label,
  onSelect,
  selected,
  small
}) {
  const { t } = useTranslation();
  const classes = useStyles({ grayscale, selected, small });

  return (
    <div className={classes.root}>
      <Card className={classes.card} onClick={onSelect} raised={selected}>
        <CardActionArea>
          <CardMedia className={classes.media} image={image} title={name}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100%"
            >
              {label}
            </Box>
          </CardMedia>
          {selected ? (
            <span className={classes.selected}>{t("creator.selected")}</span>
          ) : null}
        </CardActionArea>
      </Card>
      <Box className={classes.label}>{name}</Box>
    </div>
  );
}

export default BasicCard;
